'use es6';

import { APPOINTMENT_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Appointment = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('appointments-access'),
  objectTypeId: APPOINTMENT_TYPE_ID,
  referenceObjectType: 'APPOINTMENT_PROPERTIES'
});
export default Appointment;